import cx from 'clsx';

const Timeline: React.FC<TimelineProps> = ({ children, className }) => {
  return <ol className={className}>{children}</ol>;
};
export type TimelineProps = { className?: string };

export const TimelineItem: React.FC<TimelineItemProps> = ({ children, secondaryText }) => {
  return (
    <li
      className={cx(
        'pb-2 relative flex gap-6 last:pb-0',
        'before:w-3 before:mt-2 before:h-3 before:inline-block before:rounded-full odd:before:bg-lime-300 even:before:bg-primary-300',
        'after:h-[calc(100%-0.75rem)] after:mt-5 after:absolute after:left-0 after:ml-[calc(0.75rem/2-2px/2)] after:bottom-0 after:top-0 after:w-[2px] after:bg-gradient-to-b after:from-lime-300 after:to-primary-300 last:after:hidden',
      )}
    >
      <div className="w-full">
        <div className="text-lg">{children}</div>
        <div className="text-sm text-neutral-400">{secondaryText}</div>
      </div>
    </li>
  );
};
export type TimelineItemProps = {
  secondaryText?: React.ReactNode;
};

export default Timeline;
